module.exports = __webpack_public_path__ + "img/bingwang.5fc60734.png";